import { AsyncRenderer } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { Loader } from '../../promotions/view/components/Loader';
import { ChallengesView } from '../../challenges/view/Challenges.view';
import { useChallengesVM } from '../../challenges/view-model/Challenges.viewModel';

type ChallengesTabType = {
  programId: number;
};

export const ChallengesTab = (p: ChallengesTabType) => {
  const vm = useChallengesVM(p.programId);

  return (
    <div className="mt-5" style={{ maxWidth: '1200px' }}>
      <AsyncRenderer
        data={vm}
        loadRender={<Loader />}
        renderer={(v) => <ChallengesView {...v} />}
      />
    </div>
  );
};
